// 郭宇
// 订单列表 & 提交订单 & 订单详情 & 订单评论、优惠券、极速约单、下单

const routers = [
  {
    path: '/order-list',
    name: 'orderList',
    component: () =>
      import(/* webpackChunkName: "order-list" */ './views/order-list.vue'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/order-submit',
    name: 'orderSubmit',
    component: () =>
      import(
        /* webpackChunkName: "order-list" */
        './views/order-submit/index.vue'
      ),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/multi-order-submit',
    name: 'MultiOrderSubmit',
    component: () =>
      import(
        /* webpackChunkName: "order-list" */
        './views/order-submit/multi-order-submit.vue'
      ),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/b-order-detail',
    name: 'orderDetailB',
    component: () =>
      import(
        /* webpackChunkName: "order-detail" */
        './views/b-order-detail.vue'
      )
  },
  {
    path: '/c-order-detail',
    name: 'orderDetailC',
    component: () =>
      import(
        /* webpackChunkName: "order-detail" */
        './views/c-order-detail.vue'
      )
  },
  {
    path: '/order-comment',
    name: 'orderComment',
    component: () =>
      import(
        /* webpackChunkName: "order-comment" */ './views/order-comments/index.vue'
      )
  },
  // 优惠券 & 失效优惠券
  {
    path: '/coupons',
    name: 'coupons',
    component: () =>
      import(/* webpackChunkName: "coupons" */ './views/coupons-page.vue'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/coupons-invalid',
    name: 'couponsInvalid',
    component: () =>
      import(
        /* webpackChunkName: "coupons" */
        './views/coupons-invalid-page.vue'
      ),
    meta: {
      waitUserInfo: true
    }
  },
  // 極速約單
  {
    path: '/quick-order/quick-order',
    name: 'QuickOrderQuickOrder',
    component: () =>
      import(
        /* webpackChunkName: "quick-order-entry" */ './views/quick-order/quick-order.vue'
      ),
    meta: {
      waitUserInfo: true
    }
  },
  // 極速約單和發現老闆
  {
    path: '/quick-order/order-queue',
    name: 'QuickOrderOrderQueue',
    component: () =>
      import(
        /* webpackChunkName: "quick-order-entry" */ './views/quick-order/index.vue'
      ),
    meta: {
      waitUserInfo: true,
      keepAlive: true
    }
  },
  {
    path: '/quick-order/pre-order',
    name: 'QuickOrderPreOrder',
    component: () =>
      import(
        /* webpackChunkName: "quick-order-main" */ './views/quick-order/pre-order.vue'
      ),
    meta: {
      keepAlive: true
    }
  },
  // 旧版的B端極速約單，先注释掉 用上面的新路由
  // {
  //   path: '/quick-order/order-queue',
  //   name: 'QuickOrderOrderQueue',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "quick-order-main" */ './views/quick-order/order-queue.vue'
  //     ),
  //   meta: {
  //     waitUserInfo: true,
  //     keepAlive: true
  //   }
  // },
  {
    path: '/quick-order/waiting-order',
    name: 'QuickOrderWaitingOrder',
    component: () =>
      import(
        /* webpackChunkName: "quick-order-main" */ './views/quick-order/waiting-order.vue'
      ),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quick-order/cancel',
    name: 'QuickOrderCancelOrder',
    component: () =>
      import(
        /* webpackChunkName: "quick-order-other" */ './views/quick-order/cancel-order.vue'
      )
  },
  {
    path: '/quick-completed-order',
    name: 'QuickCompleted',
    component: () =>
      import(
        /* webpackChunkName: "quick-order-main" */ './views/quick-order/completed-order.vue'
      )
  },
  {
    path: '/quick-set',
    name: 'SetQuick',
    component: () =>
      import(
        /* webpackChunkName: "quick-order-other" */ './views/quick-order/quick-set.vue'
      )
  },
  {
    path: '/quick-order/quick-jump',
    name: 'QuickJump',
    component: () =>
      import(
        /* webpackChunkName: "quick-order-other" */ './views/quick-order/quick-jump.vue'
      ),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/b-order-refound',
    name: 'BOrderRefound',
    component: () => import('./views/b-order-refound'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/b-refound-detail',
    name: 'BRefoundDetail',
    component: () => import('./views/b-refound-detai'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/c-order-refound',
    name: 'COrderRefound',
    component: () => import('./views/c-order-refound'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/c-refound-detail',
    name: 'CRefoundDetail',
    component: () => import('./views/c-refound-detai'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/refuse-refound',
    name: 'RefuseRefound',
    component: () => import('./views/refuse-refound'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/invite-newer',
    name: 'InviteNewer',
    component: () => import('./pages/invite/index.vue'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/rebate-rule',
    name: 'Rebaterule',
    component: () => import('./pages/sale/rebate.vue'),
    meta: {
      waitUserInfo: false
    }
  },
  {
    path: '/vip-center',
    name: 'VipCenter',
    component: () => import('./pages/vip-center/index.vue'),
    meta: {
      waitUserInfo: true
    }
  },
  {
    path: '/voice-room',
    name: 'voiceRoom',
    component: () => import('./views/voice-room/index.vue'),
    meta: {
      waitUserInfo: true
    }
  },
];

export default routers;
